/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import withPieEncryption from '@vz-soe-utils/pieencryption';

import * as Actions from '../../actions';
import personalInformation from '../../../../components/Web/CreditCheck/redesign/Components/personalInformation';
import * as loaderActions from '../../../../components/common/Loader/action';
import { checkPlanReferenceData } from '../../../../utils/plansReference';
import * as cartActions from '../../../../services/Cart/actions';
import injectSaga from '../../../../utils/injectSaga';
import cartSaga from '../../../../services/Cart/sagas';
import creditStatusSaga from '../../../CreditStatus/sagas';
import * as eidActions from '../../../EidQuestions/actions';
import taggingSaga from '../../../Common/Tagging.js/sagas';
import * as taggingActions from '../../../Common/Tagging.js/actions';

const mapStateToProps = (state) => {
  const cartDetails = state.cartDetails ? state.cartDetails.cartDetailsJson : {};
  const plansReferenceData = checkPlanReferenceData(state.plansReferenceData);
  const orderDetails = cartDetails?.cartDetailsJson?.orderDetailsView || {};
  const contactDetails = cartDetails && cartDetails.primaryUserInfo ? cartDetails.primaryUserInfo : {};
  const creditReviewSuccess = state.creditCheckDetails?.creditReviewSuccess;
  const creditReviewSuccessData = state.creditCheckDetails?.creditReviewSuccessData;
  const creditReviewSuccessResponse = state.creditCheckDetails?.creditReviewSuccessResponse;
  const EidSubmitResponse = state.creditCheckDetails?.EidSubmitResponse;
  const loader = state.loader || {};
  const { marketDetails } = state.creditCheckDetails.marketDetails;
  const currentView = state.currentView || {};
  const creditCheckState = state.creditCheckDetails || {};
  const eidSubmitResponse = state.creditCheckDetails?.eidSubmitResponse;
  const eidQuestionsFromCreditStatus = state.creditStatus?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.eidQuestionnaire;
  const ShippingInfoDetails = state.shippingInfo?.ShippingInfoDetails;
  const showZipcodeError = state.creditCheckDetails?.showZipcodeError;
  const retrieveCartAPIStatus = state.cartDetails?.apiStatus;
  const belowAgeStatus = state.cartDetails?.belowAgeError;

  return {
    cartDetails,
    orderDetails,
    plansReferenceData,
    creditCheckState,
    loader,
    marketDetails,
    currentView,
    contactDetails,
    creditReviewSuccess,
    creditReviewSuccessData,
    creditReviewSuccessResponse,
    eidSubmitResponse,
    eidQuestionsFromCreditStatus,
    EidSubmitResponse,
    ShippingInfoDetails,
    showZipcodeError,
    retrieveCartAPIStatus,
    addressList: state?.cartDetails?.availableAddress ? state?.cartDetails?.availableAddress?.addresses : [],
    isEmptyAddress: state?.cartDetails?.isEmptyAddress || false,
    isPOBoxAddress: state?.cartDetails?.isPOBoxAddress || false,
    belowAgeStatus,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...Actions,
      ...loaderActions,
      ...cartActions,
      ...taggingActions,
      ...eidActions,
    },
    dispatch,
  );

const withSaga = compose(
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'creditStatus', saga: creditStatusSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
);

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withRouter(
  compose(withConnect, withSaga)(withPieEncryption(personalInformation, window.vzFlags && window.vzFlags.isProd ? 'PRODUCTION' : 'UAT')),
);
